
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class ListGridToggle extends Vue {
  @Prop(Boolean) readonly tableView!: boolean;
}
